import React, { useState } from 'react'
import { graphql } from 'gatsby'

import SEO from '~/components/seo'
import Blog from '~/components/Blog'

import QuickAdd from '~/components/QuickAdd'
import Tabs from '~/components/Tabs'
import RelatedProducts from '~/components/RelatedProducts'
import ReviewsScroller from '~/components/ReviewsScroller'
import Circle from '~/components/Circle'

import { Img, TwoColumnGrid } from '~/utils/styles'
import { formatTitle, getNutritionTable, getIngredients } from '~/utils/helpers'
import styled from '@emotion/styled'
import {
  ProductTitle,
  Container,
  Product,
  Image,
  Right,
  Left,
  Upsell,
} from './styles'
import { breakpoints } from '~/utils/styles'

const ProductPage = ({ data, initialVariant = null, upsell = null }) => {
  const product = data.shopifyProduct
  const isWholesale = product.tags.includes('wholesale')
  const isSubscription = product.tags.includes('subscription')
  const isTaster = product.handle === 'taster-pack'

  const selectedVariant = initialVariant
    ? product.variants.filter(variant => {
        return variant.title === initialVariant
      })[0]
    : product.variants[0]

  const [variant, setVariant] = useState({ ...selectedVariant })

  const title = isWholesale
    ? formatTitle('Wholesale + Direct<br/>CBD Snack Bar<br/>')
    : formatTitle(product.title)

  const showTabs = !isWholesale && !isTaster && !isSubscription

  return (
    <>
      <SEO title={product.title} description={product.description} />
      <Padding>
        <div id="feefo-service-review-floating-widgetId"></div>
        <Container style={{ minHeight: '80vh' }}>
          <TwoColumnGrid style={{ width: '100%', maxWidth: 1200 }}>
            <Left>
              <Image>
                <Circle handle={product.handle} />
                <Img
                  fluid={variant.image.localFile.childImageSharp.fluid}
                  alt={product.title}
                  style={{ width: '100%', marginBottom: 0 }}
                />
              </Image>
            </Left>
            <Right>
              <Product>
                <div style={{ width: '100%' }}>
                  <ProductTitle
                    dangerouslySetInnerHTML={{
                      __html: title,
                    }}
                  />

                  {upsell === 'Rave Coffee' && (
                    <Upsell>
                      <strong>Rave Coffee </strong>Redeem your code for 50% off
                      a Pack of 6. Yum!
                    </Upsell>
                  )}

                  <QuickAdd
                    variants={product.variants}
                    selectedVariant={variant}
                    _setVariant={setVariant}
                    isWholesale={isWholesale}
                    maxWidth={400}
                    justifyContent="flex-start"
                    tags={product.tags}
                    handle={product.handle}
                    showInline={isWholesale}
                  />

                  <div style={{ marginTop: 20, fontSize: 20 }}>
                    {showTabs ? (
                      <Tabs>
                        <div label="Description">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: product.descriptionHtml,
                            }}
                            style={{ marginTop: '1em' }}
                          />
                        </div>
                        {!isWholesale && !isTaster && (
                          <div label="Ingredients">
                            {getIngredients(product.handle)}
                          </div>
                        )}
                        {!isWholesale && !isTaster && (
                          <div label="Nutrition">
                            {getNutritionTable(product.handle)}
                          </div>
                        )}
                      </Tabs>
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: product.descriptionHtml,
                        }}
                      />
                    )}
                  </div>
                </div>
              </Product>
            </Right>
          </TwoColumnGrid>
        </Container>
        {!isWholesale && (
          <>
            <ReviewsScroller />
            <RelatedProducts currentHandle={product.handle} />
            <Blog limit={4} />
          </>
        )}
      </Padding>
    </>
  )
}

const Padding = styled.div`
  padding-top: 133px;

  @media (max-width: ${breakpoints.s}px) {
    padding-top: 108px !important;
  }
`

export const query = graphql`
  query($handle: String!) {
    shopifyProduct(handle: { eq: $handle }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      options {
        id
        name
        values
      }
      variants {
        id
        title
        price
        availableForSale
        shopifyId
        selectedOptions {
          name
          value
        }
        image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 910) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
      }
      tags
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      images {
        originalSrc
        id
        localFile {
          childImageSharp {
            fluid(maxWidth: 910) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    }
  }
`

export default ProductPage
